import { PAPEIS_DO_POWER_DATA } from 'dashboard/routes/dashboard/settings/powerData/acesso';

/**
 * O item "PowerData" da barra lateral, ou nada.
 *
 * Aparece para o administrador e o atendente de TODA conta, sem a flag `power_data`
 * (POWERDATA-ACESSO-01, 30/09/2026). O super admin entra sempre, por ser papel da plataforma
 * e não da conta. O supervisor (`moderator`) fica de fora: o servidor não o deixa passar, e a
 * porta que ele veria só levaria a uma tela sem nada. A exceção é o supervisor que recebeu
 * `powerdata_manage` num papel personalizado: aí o servidor deixa, e o item aparece.
 *
 * Mora aqui, e não solto no `computed` de `Sidebar.vue`, para o spec alcançar a regra — a
 * lição do `powerAppMenu`.
 *
 * Sem `activeOn`: as duas telas do PowerData são standalone e não renderizam esta barra, então
 * nenhum nome de rota poderia casar. O item é a porta de entrada, sem estado ativo para mostrar.
 *
 * @param {Object} options
 * @param {Function} options.t - o `t` do vue-i18n
 * @param {Function} options.accountScopedRoute - de `useAccount`
 * @param {boolean} options.isSuperAdmin - de `useAdmin`
 * @param {string} options.role - o papel na conta atual (`getCurrentRole`)
 * @param {boolean} [options.concedidoPorPapel] - `powerdata_manage` recebida num papel
 *   personalizado. Desde 01/10/2026 o servidor deixa passar quem a tem, inclusive um supervisor.
 * @param {Function} [options.decide] - o `decide` do `useAcesso` (ACESSO-01, L8b): com a chave
 *   ACESSO_GRANULAR ligada, o `powerdata:read`, o escopo da rota; desligada, o papel, como acima.
 *   Sem ele, o papel.
 * @returns {Array<Object>} o item, ou vazio
 */
export function buildPowerDataItems({
  t,
  accountScopedRoute,
  isSuperAdmin,
  role,
  concedidoPorPapel = false,
  decide = (_escopo, hoje) => hoje(),
}) {
  const entra =
    isSuperAdmin ||
    decide(
      'powerdata:read',
      () => concedidoPorPapel || PAPEIS_DO_POWER_DATA.includes(role)
    );
  if (!entra) return [];

  return [
    {
      name: 'PowerData',
      icon: 'i-lucide-database',
      label: t('SIDEBAR.POWER_DATA'),
      to: accountScopedRoute('power_data_index'),
    },
  ];
}
